module.exports = __webpack_public_path__ + "static/media/tovoLogo.4921d3d2.png";